/* jshint strict:false */

/*/ ==========================================================================
	FORMMAIL TRANSLATIONS FUNCTION
	Should we eventually create a getText function for other pieces of text?
========================================================================== /*/

var getCheckText = function() {
	switch ($('html').attr('lang')) {
		case "es": 	return '&nbsp;Clic para verificar que es un ser humano.';
		case "pt": 	return '&nbsp;Clique para verificar se você é humano.';
		default: 	return '&nbsp;Click to verify you are human.';
	}
};

/*/ ==========================================================================
	GET URL PARAMETER FUNCTION
	http://stackoverflow.com/questions/19491336/get-url-parameter-jquery-or-how-to-get-query-string-values-in-js
========================================================================== /*/

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

/*/ ==========================================================================
	LINK DIRECTLY TO TABS AND MODALS v2.0
	Rewritten on November 30, 2016
========================================================================== /*/
 
$(function() {
	var modal = getUrlParameter('modal'), tab = getUrlParameter('tab');
	
	if (modal !== undefined) {
		$('#modal-' + modal).modal('show');
	}
	
	if (tab !== undefined) {
		$('a[href="#tab-' +tab+ '"]').tab('show');
	}
	
	console.log("Tab: " + tab);
});


/*/ ==========================================================================
	Multi-Language Formmail Init (Simple Version)
	Stephen Ginn at Crema Design Studio
	Created on 12.07.2016, Modified on 08.01.2017
	
	*	based on 3.3.7/init-formmail.js with simpler, auto init
	*	HTML5/JS with FormMail Fallback
	*	this form requires javascript, but so did the other one ...
	*	inserts checkbox captcha
	*	checks the value of the honeypot on every blur
========================================================================== /*/

$(".contact-form").each(function (e) {
	var $form = $(this), $btn = $form.find('.btn-submit');
			
	// Dynamically insert a required Checkbox Captcha with multiple language options	
	var chkField = '<label><input type="checkbox" name="is_human_'+e+'" required>'+getCheckText()+'</label>';
	$form.find(".captcha").prepend(chkField);
	
	// Automatically compile a list of all HTML5 required attributes
	var msgURL = location.protocol + '//' + location.hostname + location.pathname,
		successURL = msgURL + "?modal=success",
        errorURL   = msgURL + "?modal=error";
});


/*/ ==========================================================================
	HTML5/JS Honeypot Validation
	Stephen Ginn at Crema Design Studio
	Updated 06.03.2015, 12.07.2016, 07.03.17
========================================================================== /*/

// Please Note: it looks like there might be some newer code in Georgia Blue's plugins-v2a.js.liquid
function validateForm($form) {
	var $btn = $form.find('.btn-submit'),
		isValid = true,
		honeychk = $form.find('.captcha input[type=checkbox]').is(":checked"),
		honeypot = $form.find('input.honeypot').val();
	
	console.log("Honeypot: " + honeypot);
	console.log("Checkbox: " + honeychk);
	
	// Mark form invalid if a required field is missing
	$form.find("input[required], select[required], textarea[required]").each(function() {			
		if($(this).val() === '') {
			isValid = false;
		}
	});
	
	// Mark form invalid if a spammer fills out the honeypot OR doesn't click on the checkbox.
	if (honeychk === false || honeypot !== '') {
		isValid = false;
	}
	
	if (isValid === true) {
		$btn.removeClass("disabled").attr('type', 'submit');
		$form.attr("action",$form.data("action")).attr("method","POST");
	} else {
		$btn.addClass("disabled").attr('type', 'button');
		$form.attr("action","#").attr("method","");
	}
	
	return isValid;
}

$('.contact-form input, .contact-form select, .contact-form textarea').blur(function() {
	var $form = $(this).closest('form');
	console.log("Form Validation: " + validateForm($form));
});

// Checkboxes and Radios need a separate function, since they can't be activated by the click event
$('.contact-form input[type=checkbox], .contact-form input[type=radio]').click(function() {
	var $form = $(this).closest('form');
	console.log("Form Validation: " + validateForm($form));
});